import { open_modal, open_modal_withmode, close_modal, modal_mode_fullscreen } from "../../actions/actionConstants";

const updateModal = (state, action) => {
    if (state === undefined) {
        return {
            opened: false,
            dialogMode: modal_mode_fullscreen,
            dialog: "" //"CHOOSECMPX_DIALOG", ///GRAPHINTERVALS_DIALOG
        };
    }

    switch (action.type) {
        case open_modal:
            return {
                opened: true,
                dialog: action.payload,
                dialogMode: null
            };
        case open_modal_withmode:
            return {
                opened: true,
                dialog: action.payload.dialog,
                dialogMode: action.payload.mode
            };
        case close_modal:
            return {
                opened: false,
                dialog: null
            };
        default:
            return state.app.modal;
    }
};

export default updateModal;
